// "use client";
// import { Control, UseFormClearErrors } from "react-hook-form";
// import { IconPlus } from "@tabler/icons-react";
// import { useState } from "react";
// import VariableDropdown from "./VariableDropdown";
// import VariableTextareaField from "./VariableTextarea";
// import NewSelectInput from "../../../components/NewSelectInput";
// import Checkbox from "../../../components/common/CheckBox";
// type AddNewTriggerProps = {
//   register: any;
//   errors: any;
//   setValue: any;
//   watch: any;
//   clearErrors?: UseFormClearErrors<any>;
//   control: Control<any>;
//   reset: () => void;
// };

// const AddNewTrigger = ({ register, errors }: AddNewTriggerProps) => {
//   const [showDropdown, setShowDropdown] = useState(false);
//   return (
//     <div className="grid grit-cols-4 gap-4 py-4">
//       {/* Step Name + Event */}
//       <NewSelectInput
//         label="Event / Condition"
//         name="recipients"
//         className="col-span-4"
//         selectOptions={[]}
//       />

//       <div className="relative w-full col-span-4">
//         <div className="flex justify-between items-center">
//           <label className="font-medium text-gray-700">Message</label>

//           <button
//             type="button"
//             onClick={() => setShowDropdown(!showDropdown)}
//             className="flex items-center gap-1 px-3 py-1.5 text-sm rounded-full border border-[#0088FF] text-[#007BFF] bg-[#007BFF1A] hover:bg-[#007BFF] hover:text-white"
//           >
//             <IconPlus size={15} /> Add Variable
//           </button>
//         </div>

//         {/* Dropdown below the button */}
//         {showDropdown && (
//           <div className="absolute top-8 left-0 w-full min-h-[300px] z-50">
//             <VariableDropdown
//               onSelect={(value) => {
//                 console.log("Selected:", value);
//                 setShowDropdown(false);
//               }}
//             />
//           </div>
//         )}
//       </div>
//       <div className="col-span-2 space-y-1">
//         <label className="text-[#1E293] text-sm">English</label>
//         <VariableTextareaField
//           name="messageEnglish"
//           rows={5}
//           error={errors?.messageEnglish?.message}
//           register={register}
//           validation={{ required: "This field is required" }}
//           placeholder="Your order orderId has been Status"
//         />
//       </div>
//       <div className="col-span-2 space-y-1">
//         <label className="text-[#1E293] text-sm">Arabic</label>
//         <VariableTextareaField
//           name="messageEnglish"
//           rows={5}
//           error={errors?.messageEnglish?.message}
//           register={register}
//           validation={{ required: "This field is required" }}
//           placeholder="Your order orderId has been Status"
//         />
//       </div>
//       <div className="col-span-2 space-y-1">
//         <label className="text-[#1E293] text-sm">Channel</label>

//         <div className=" border border-[#D8D8D8] bg-white resize-none rounded-2xl px-4 text-sm outline-none">
//           <Checkbox
//             name="contactType"
//             label=""
//             otherName="flex items-center"
//             valuesArr={[
//               { value: "SMS", text: "SMS" },
//               { value: "WHATSAPP", text: "Whatsapp" },
//             ]}
//             register={register}
// validation={{
//   validate: (value: any) =>
//     value?.length > 0 ? true : "At least one option required",
// }}
// error={errors?.contactType}
//           />
//         </div>
//       </div>
// <div className="col-span-2 space-y-1">
//   <label className="text-[#1E293] text-sm">Send Message in</label>

//   <div className=" border border-[#D8D8D8] bg-white resize-none rounded-2xl px-4 text-sm outline-none">
//     <Checkbox
//       name="contactType"
//       label=""
//       otherName="flex items-center"
//       valuesArr={[
//         { value: "ENGLISH", text: "English" },
//         { value: "ARABIC", text: "Arabic" },
//       ]}
//       register={register}
//       validation={{
//         validate: (value: any) =>
//           value?.length > 0 ? true : "At least one option required",
//       }}
//       error={errors?.contactType}
//     />
//   </div>
// </div>
//       <div className="col-span-4">
//         <button
//           type="button"
//           className="px-6 py-2 bg-[#FBD037] text-[#212121] font-medium rounded-full"
//         >
//           Create
//         </button>
//       </div>
//     </div>
//   );
// };

// export default AddNewTrigger;

"use client";

import { useEffect, useState } from "react";
import { IconPlus } from "@tabler/icons-react";
import { UseFormClearErrors, Control } from "react-hook-form";
import toast from "react-hot-toast";

import VariableDropdown from "./VariableDropdown";
import VariableTextareaField from "./VariableTextarea";
import SelectInput from "../../../components/Select";
import Checkbox from "../../../components/common/CheckBox";
import {
  useFetchNotificationVariables,
  useFetchOrderStatus,
  usePostNotificationTemplate,
  useUpdateNotificationTemplate,
} from "../../../apis/tamplateNotification";

type AddNewTriggerProps = {
  register: any;
  errors: any;
  setValue: any;
  watch: any;
  reset: () => void;
  onSuccess: () => void;
  clearErrors?: UseFormClearErrors<any>;
  control: Control<any>;
  mode?: "create" | "edit";
  templateData?: any;
};

const AddNewTrigger = ({
  register,
  errors,
  setValue,
  watch,
  reset,
  onSuccess,
  mode = "create",
  templateData,
}: AddNewTriggerProps) => {
  const [showDropdown, setShowDropdown] = useState(false);

  const selectedStatus = watch("orderStatus");

  const { data: orderStatuses = [] } = useFetchOrderStatus();
  const { data: variables = [] } =
    useFetchNotificationVariables(selectedStatus);

  const { mutate: createTemplate } =
    usePostNotificationTemplate();
  const { mutate: updateTemplate } =
    useUpdateNotificationTemplate(templateData?.id);

  useEffect(() => {
    if (mode === "edit" && templateData) {
      setValue("orderStatus", templateData.orderStatus, { shouldDirty: true });
      setValue("channels", templateData.channels || [], { shouldDirty: true });
      setValue("languages", templateData.languages || [], {
        shouldDirty: true,
      });
      setValue("messageEnglish", templateData.messageEnglish || "", {
        shouldDirty: true,
      });
      setValue("messageArabic", templateData.messageArabic || "", {
        shouldDirty: true,
      });
    }
  }, [mode, templateData]);

  useEffect(() => {
    register("orderStatus", { required: true });
  }, [register]);

  // ------------------------------------------------

  const handleVariableInsert = (placeholder: string) => {
    const current = watch("messageEnglish") || "";
    const updated = current ? `${current} ${placeholder}` : placeholder;

    setValue("messageEnglish", updated, {
      shouldDirty: true,
      shouldTouch: true,
    });

    setShowDropdown(false);
  };

const handleSubmit = () => {
  const payload = {
    orderStatus: watch("orderStatus"),
    channels: watch("channels") || [],
    languages: watch("languages") || [],
    messageEnglish: watch("messageEnglish"),
    messageArabic: watch("messageArabic"),
  };

  if (mode === "edit" && !templateData?.id) {
    toast.error("Invalid template ID");
    return;
  }

  if (mode === "edit") {
    updateTemplate(
      { id: templateData.id, ...payload },
      {
        onSuccess: (res: any) => {
          toast.success(res?.message || "Template updated successfully");
          onSuccess();
        },
        onError: (err: any) => {
          const msg =
            err?.response?.data?.message ||
            err?.response?.data?.statusMessage ||
            err?.message ||
            "Failed to update template";

          toast.error(msg);
        },
      }
    );
  } else {
    createTemplate(payload, {
      onSuccess: (res: any) => {
        toast.success(res?.message || "Template created successfully");
        reset();
        onSuccess();
      },
      onError: (err: any) => {
        const msg =
          err?.response?.data?.message ||
          err?.response?.data?.statusMessage ||
          err?.message ||
          "Failed to create template";

        toast.error(msg);
      },
    });
  }
};

  /* ===================== UI ===================== */

  return (
    <div className="grid grid-cols-4 gap-4 py-4">
      {/* Order Status */}
      <SelectInput
        label="Event / Condition"
        name="orderStatus"
        className="col-span-4"
        selectOptions={orderStatuses.map((s: any) => ({
          text: s.label ?? s.replace(/_/g, " "),
          value: s.value ?? s,
        }))}
        value={selectedStatus}
        formSetValue={setValue}
      />

      {/* Message Header */}
      <div className="relative col-span-4">
        <div className="flex justify-between items-center">
          <label className="font-medium">Message</label>

          <button
            type="button"
            disabled={!selectedStatus}
            onClick={() => setShowDropdown(!showDropdown)}
            className="flex items-center gap-1 px-3 py-1.5 text-sm rounded-full border hover:bg-[#007BFF] hover:text-white"
          >
            <IconPlus size={15} /> Add Variable
          </button>
        </div>

        {showDropdown && (
          <div className="absolute top-8 left-0 w-full z-50">
            <VariableDropdown
              variables={variables}
              onSelect={handleVariableInsert}
            />
          </div>
        )}
      </div>

      {/* English */}
      <div className="col-span-2 space-y-1">
        <label className="text-[#1E293] text-sm">English</label>
        <VariableTextareaField
          name="messageEnglish"
          rows={5}
          register={register}
          error={errors?.messageEnglish}
          placeholder="Hello Your English Message"
        />
      </div>

      {/* Arabic */}
      <div className="col-span-2 space-y-1">
        <label className="text-[#1E293] text-sm">Arabic</label>
        <VariableTextareaField
          name="messageArabic"
          rows={5}
          register={register}
          error={errors?.messageArabic}
          placeholder="Hello Your Arabic Message"
        />
      </div>

      {/* Channels */}

      <div className="col-span-2 space-y-1">
        <label className="text-[#1E293] text-sm">Channel</label>

        <div className=" border border-[#D8D8D8] bg-white resize-none rounded-2xl px-4 text-sm outline-none">
          <Checkbox
            name="channels"
            label=""
            otherName="flex items-center"
            valuesArr={[
              { value: "SMS", text: "SMS" },
              { value: "WHATSAPP", text: "Whatsapp" },
            ]}
            register={register}
            validation={{
              validate: (value: any) =>
                value?.length > 0 ? true : "At least one option required",
            }}
            error={errors?.channels}
          />
        </div>
      </div>

      {/* Languages */}
      <div className="col-span-2 space-y-1">
        <label className="text-[#1E293] text-sm">Send Message in</label>

        <div className=" border border-[#D8D8D8] bg-white resize-none rounded-2xl px-4 text-sm outline-none">
          <Checkbox
            name="languages"
            label=""
            otherName="flex items-center"
            valuesArr={[
              { value: "EN", text: "English" },
              { value: "AR", text: "Arabic" },
            ]}
            register={register}
            validation={{
              validate: (value: any) =>
                value?.length > 0 ? true : "At least one option required",
            }}
            error={errors?.languages}
          />
        </div>
      </div>

      {/* Submit */}
      <div className="col-span-4 flex justify-start">
        <button
          type="button"
          onClick={handleSubmit}
          className="px-6 py-2 rounded-full bg-[#FBD037]"
        >
          {mode === "edit" ? "Update" : "Create"}
        </button>
      </div>
    </div>
  );
};

export default AddNewTrigger;
